export function getFromLocalStorage(storage: Storage, keyName: string): string | null {
    return storage.getItem(keyName)
}

export function itemExists(storage: Storage, keyName: string): boolean{
    return storage.getItem(keyName) ? true : false
}

export function saveToLocalStorage(storage: Storage, keyName: string, value: string) {
    storage.setItem(keyName, value)
}